import { u as n } from "./use-cart-D8NOb7eE.js";
import { u, o as c, b as s, c as l, l as i, w as p, i as d, t as f } from "./define-element-XpjsV6s1.js";
import { B as y } from "./Button-D5lKR5Sd.js";
const C = {
  __name: "ProductBuyButton",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    productSlug: String,
    quantity: {
      type: Number,
      default: 1
    },
    label: {
      type: String,
      default: "Add to Cart"
    }
  },
  setup(e) {
    const { addToCart: o } = n(), t = e;
    function a() {
      o(t.productSlug, t.quantity);
    }
    const r = u("container");
    return c(() => {
      s(r.value, t.inheritStyle);
    }), (S, m) => (l(), i(y, {
      ref: "container",
      onClick: a,
      class: "offset-product-buy-button"
    }, {
      default: p(() => [
        d(f(e.label), 1)
      ]),
      _: 1
    }, 512));
  }
};
export {
  C as _
};
